export interface IStockItem {
    ocorrenciaNo: number;
    tipoMaterial: string;
    codigo: number;
    titulo: string;
    habilitado: boolean;
    quantidadeEmbalagem: number;
}
